import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withUrlGenerator } from '@folklore/react-app';
import { withRouter } from 'react-router';

import Logo from './Logo';
import Menu from './Menu';

import styles from '../../../styles/partials/header.scss';

const propTypes = {
    sticky: PropTypes.bool,
    dark: PropTypes.bool,
    menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    urlGenerator: PropTypes.shape({
        route: PropTypes.func,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }).isRequired,
};

const defaultProps = {
    sticky: false,
    dark: false,
};

class Header extends Component {
    constructor(props) {
        super(props);

        this.onClickHamburger = this.onClickHamburger.bind(this);

        this.state = {
            menuVisible: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        const locationChanged = nextProps.location !== this.props.location;
        if (locationChanged) {
            this.setState({
                menuVisible: false,
            });
        }
    }

    onClickHamburger() {
        this.setState({
            menuVisible: !this.state.menuVisible,
        });
    }

    render() {
        const {
            sticky, dark, menuItems, urlGenerator,
        } = this.props;
        const { menuVisible } = this.state;

        const mainColsClassNames = classNames({
            [styles.cols]: true,
            [styles.colsMain]: true,
        });

        const mobileColsClassNames = classNames({
            [styles.cols]: true,
            [styles.colsMobile]: true,
        });

        const logoColClassNames = classNames({
            [styles.col]: true,
            [styles.colLogo]: true,
        });

        const hamburgerColClassNames = classNames({
            [styles.col]: true,
            [styles.colHamburger]: true,
        });

        const menuColClassNames = classNames({
            [styles.col]: true,
            [styles.colMenu]: true,
        });

        const mobileMenuClassNames = classNames({
            [styles.mobileMenu]: true,
        });

        return (
            <div
                className={classNames({
                    [styles.container]: true,
                    [styles.sticky]: sticky,
                    [styles.dark]: dark,
                    [styles.menuVisible]: menuVisible,
                })}
            >
                <div
                    className={classNames({
                        [styles.cols]: true,
                        [styles.full]: true,
                    })}
                >
                    <div className={styles.col}>
                        <div className={styles.inner}>
                            <div className={mainColsClassNames}>
                                <div className={logoColClassNames}>
                                    <div className={mobileColsClassNames}>
                                        <div className={styles.col}>
                                            <div className={styles.logo}>
                                                <Logo
                                                    link={urlGenerator.route('home')}
                                                    expand
                                                    dark={dark && !menuVisible}
                                                />
                                            </div>
                                        </div>
                                        <div className={hamburgerColClassNames}>
                                            <button
                                                type="button"
                                                className={styles.hamburger}
                                                onClick={this.onClickHamburger}
                                            >
                                                <span className={styles.line} />
                                                <span className={styles.line} />
                                                <span className={styles.line} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className={menuColClassNames}>
                                    <Menu
                                        items={menuItems}
                                        className={styles.menu}
                                        itemClassName={styles.item}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={mobileMenuClassNames}>
                            <Menu
                                items={menuItems}
                                className={styles.menu}
                                itemClassName={styles.item}
                                linkClassName={styles.link}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

const WithUrlGeneratorContainer = withUrlGenerator()(Header);
const WithRouterContainer = withRouter(WithUrlGeneratorContainer);
export default WithRouterContainer;



// WEBPACK FOOTER //
// ./js/components/partials/Header.jsx